import { call, takeEvery, put } from "redux-saga/effects"
import { createActions } from "reduxsauce"
import { sendQuery } from "api/graphql"
import { get, isArray } from "lodash"
import { put as putApi, post as postApi, del as delApi } from "api"
import { Creators as DataCreators } from "./data"

export const { Types, Creators } = createActions({
  update: ["query", "variables", "account", "options", "callback"],
}, {
  prefix: "ompnt/hooks/",
})

function* updateSaga({ query, variables, account, options = {}, callback }) {
  try {
    let result, errorMessage
    if (options.verb === "PUT") {
      // [TODO] implement other verbs as needed
      result = yield call(putApi, query, variables)
    } else if (options.verb === "POST") {
      result = yield call(postApi, query, variables)
    } else if (options.verb === "DELETE") {
      result = yield call(delApi, query, variables)
    } else {
      result = yield call(sendQuery, query, variables, account, !!options.beta)
      errorMessage = get(result, "apiMessages.errors.0.message", null)
    }
    yield call(callback, errorMessage, result)

    if (!errorMessage && options.reloadData) {
      let collections = options.reloadData
      if (!isArray(collections)) {
        collections = [collections]
      }
      yield put(DataCreators.resetCollections(collections))
    }
  } catch (error) {
    yield call(callback, "An unknown error has happened, please try again later", error)
  }
}

export function* saga() {
  yield takeEvery(Types.UPDATE, updateSaga)
}
